export function getRowStr(facet, row) {
    var _a;
    return `${(facet.startsWith('metadata.')
        ? (_a = row.metadata) === null || _a === void 0 ? void 0 : _a[facet.replace('metadata.', '')]
        : row[facet]) || ''}`;
}
